import Headroom from "react-headroom";
import { useMenuContext } from "context/MenuContext";
import MenuNavbarContent from "./MenuNavbarContent";

interface Props {
  description: string;
  openSideBar: () => void;
}
const MenuNavBar: React.FC<Props> = ({ description, openSideBar }) => {
  const { business_name, navbarDesign } = useMenuContext();
  const title = navbarDesign.title || business_name;
  const subtitle = navbarDesign.subtitle || description;

  return (
    <header>
      <Headroom downTolerance={0} disableInlineStyles>
        <MenuNavbarContent
          preview={false}
          openSideBar={openSideBar}
          title={title}
          subtitle={subtitle}
          backgroundColor={navbarDesign.backgroundColor}
          textColor={navbarDesign.textColor}
        />
      </Headroom>
    </header>
  );
};

export default MenuNavBar;
